import { AccountSearchInput, FilterType } from '@gripp/shared-ui';
import { StyleSheet, View } from 'react-native';
import { FilterBar } from '../../shared/components/filter/filterBar';

export const AccountsFilters = () => {
  return (
    <View style={styles.filtersContainer}>
      <View style={styles.searchContainer}>
        <AccountSearchInput />
      </View>
      <FilterBar
        filterButtonTypes={[
          FilterType.ACCOUNTGROUPS,
          FilterType.ACCOUNTTYPES,
          FilterType.ACCOUNTCOLUMNS,
        ]}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  searchContainer: {
    width: 390,
    marginRight: 20,
  },
});
